<template>
  <div>
    <div class="exceptions">
      <div v-for="(exception, index) in exceptions" :key="index">
        <exception-date-range
          v-if="exception.type == 'dateRange'"
          :id="index"
          :exception="exception"
          @change="emitChange"
          @delete="() => removeException(exception)"
        >
        </exception-date-range>
        <exception-dates
          v-else-if="exception.type == 'dates'"
          :id="index"
          :exception="exception"
          @change="emitChange"
          @delete="() => removeException(exception)"
        >
        </exception-dates>
        <exception-weekdays
          v-else-if="exception.type == 'weekdays'"
          :id="index"
          :exception="exception"
          @change="emitChange"
          @delete="() => removeException(exception)"
        >
        </exception-weekdays>
      </div>
    </div>

    <div>
      <h3>{{ $t("components.loanable.exceptions.add_exception") }}</h3>
      <div class="new_exception_row">
        <icon-button
          icon="calendar-day"
          variant="ghost-secondary"
          @click="addException('weekdays')"
        >
          {{ $t("components.loanable.exceptions.weekdays.type") }}
        </icon-button>
        <icon-button icon="calendar-week" variant="ghost-secondary" @click="addException('dates')">
          {{ $t("components.loanable.exceptions.dates.type") }}
        </icon-button>
        <icon-button
          icon="calendar-range"
          variant="ghost-secondary"
          @click="addException('dateRange')"
        >
          {{ $t("components.loanable.exceptions.date_range.type") }}
        </icon-button>
      </div>
    </div>
  </div>
</template>

<script>
import ExceptionDateRange from "@/components/Loanable/ExceptionDateRange.vue";
import ExceptionDates from "@/components/Loanable/ExceptionDates.vue";
import ExceptionWeekdays from "@/components/Loanable/ExceptionWeekdays.vue";
import IconButton from "@/components/shared/IconButton.vue";

export default {
  name: "LoanableExceptions",
  components: {
    ExceptionDateRange,
    ExceptionDates,
    ExceptionWeekdays,
    IconButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    exceptions: {
      type: Array,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  methods: {
    addException(type) {
      if (!this.disabled) {
        this.$emit("input", [
          ...this.exceptions,
          {
            available: this.mode === "never",
            type,
            scope: [],
            period: "00:00-24:00",
          },
        ]);
      }
    },
    emitChange(target, key, value) {
      const newExceptions = [...this.exceptions];
      const index = newExceptions.indexOf(target);
      const newTarget = { ...target };
      newTarget[key] = value;

      newExceptions.splice(index, 1, newTarget);
      this.$emit("input", newExceptions);
    },
    removeException(exception) {
      if (!this.disabled) {
        const newExceptions = [...this.exceptions];
        const index = newExceptions.indexOf(exception);
        newExceptions.splice(index, 1);
        this.$emit("input", newExceptions);
      }
    },
  },
};
</script>

<style lang="scss">
@import "~bootstrap/scss/mixins/breakpoints";
.exceptions {
  .exception {
    width: 100%;
    display: inline-block;
    box-shadow: $small-shadow;
    margin-bottom: 1rem;
  }
}
/* Layout utility class for exceptions. */
@media (max-width: 750px) {
  .l-exception-frame {
    &__content {
      flex-direction: column;
    }
  }
}

.l-exception-frame {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &__content {
    display: flex;
    gap: 1rem;
    flex-grow: 1;
  }
  &__date {
    flex-grow: 1;
    flex-basis: 50%;
  }
  &__time {
    flex-grow: 1;
    flex-basis: 50%;
  }
  &__actions {
    align-self: flex-end;
  }
}
.new_exception_row {
  flex-wrap: wrap;
  display: flex;
  gap: 0.5rem;
}
</style>
